import { httpClient } from '../httpClient';

export const dataflowAuditApi = {
  listAuditTrail: (params) =>
    httpClient.get('/dataflow/audit', { params }),

  getEntityHistory: (entityType, entityId, params) =>
    httpClient.get(`/dataflow/audit/entity/${entityType}/${entityId}`, { params }),

  logAccess: (reason, scope) =>
    httpClient.post('/dataflow/audit/access', { reason, scope }),
};
